import styled from 'styled-components'

export const OverflowWrapper = styled.div``

export const Categories = styled.div`
  display: flex;
  gap: 30px;

  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const CategoriesWrapper = styled.div<{ showMore: boolean }>`
  @media (max-width: 767px) {
    .swiper-wrapper {
      display: grid;
      grid-template-columns: minmax(0, 50%) minmax(0, 50%);
      gap: 16px;
    }
    ${Categories} {
      > a {
        width: 100%;
      }
    }

    ${({ showMore }) =>
      !showMore &&
      `
      .swiper-slide:nth-child(n+7) {
        display: none;
      }
    `}
  }
`

export const ShowMore = styled.span`
  display: none;
  font-size: 14px;
  font-weight: var(--font-regular);
  text-decoration: underline;
  color: var(--brand-secondary);
  margin-top: 32px;

  @media (max-width: 767px) {
    display: block;
  }
`
